var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRightFarmers = function SvgIconRightFarmers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "65px",
    height: "20px",
    viewBox: "0 0 65 20",
    enableBackground: "new 0 0 65 20",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.344,5.454H9.619c-0.318,0-0.612-0.229-0.639-0.546c-0.03-0.355,0.249-0.652,0.597-0.652h53.056 C63.232,4.786,62.867,5.454,62.344,5.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.344,8.837H10.877c-0.318,0-0.612-0.229-0.639-0.547c-0.03-0.354,0.249-0.651,0.597-0.651h51.797 C63.232,8.169,62.867,8.837,62.344,8.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.344,12.199H11.065c-0.319,0-0.612-0.23-0.639-0.547C10.395,11.297,10.674,11,11.022,11h51.61 C63.232,11.531,62.867,12.199,62.344,12.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.344,15.604H9.619c-0.318,0-0.612-0.229-0.639-0.545c-0.03-0.355,0.249-0.652,0.597-0.652h53.056l0,0 C63.232,14.936,62.867,15.604,62.344,15.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.344,18.965H2.698c-0.318,0-0.612-0.229-0.639-0.545c-0.03-0.355,0.249-0.652,0.597-0.652 c4.283,0,7.767-3.484,7.767-7.767c0-4.267-3.456-7.739-7.715-7.767C2.387,2.231,2.089,2.01,2.06,1.691 C2.027,1.333,2.307,1.035,2.656,1.035c4.943,0,8.965,4.022,8.965,8.966c0,3.302-1.795,6.193-4.46,7.75 c-0.009,0.004-0.005,0.018,0.005,0.018h55.467C63.232,18.297,62.867,18.965,62.344,18.965z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRightFarmers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-right-farmers.99c2045c.svg";
export { ForwardRef as ReactComponent };